import * as React from 'react';
import '@styles/pages/tab1.scss';
import {StageDefault, StageCurrent} from '@/context.ts';
import { fetch, HourChampionRsp, ChampionInfo, RankItem } from '@/fetch.ts';
/* 这种写法在IE下报错 */
// import Swiper from 'swiper';
import Swiper from 'swiper/js/swiper.min.js';
import 'swiper/swiper.scss';
import NoneData from '@hook/public/none.tsx';
import HourItem from '@hook/public/hourItem.tsx';
import hourback from '@images/hourback.png';
import hourback1 from '@images/hourback1.png';
const { useState, useEffect, useContext } = React;
let swiperNew = null;
const Hour: React.FC<any> = () => {
  const {tabCurrent, iStage} = useContext(StageDefault);
  const {current} = useContext(StageCurrent);
  const [list, List] = useState<ChampionInfo[]>([]);
  const [hours, Hours] = useState<number>(0);
  useEffect(() => {
    if (current === -1) return;
    fetch.getHourChampion(
      {
        iMatchId: tabCurrent,
        iStage: current === 0 ? iStage : current,
        iArea: 0,
      }
    )
      .then((rsp: HourChampionRsp) => {
        List(rsp.vChampionList.value);
        const len = rsp.vChampionList.value.length;
        if (len !== 0) {
          Hours(rsp.vChampionList.value[len - 1].iHour);
          swiperNew = null;
          // tslint:disable-next-line: no-unused-expression
          swiperNew = new Swiper('.swiper-container', {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            initialSlide: rsp.vChampionList.value.length - 1,
            simulateTouch: false,
            slidesPerView: 1,
            observe: true,
            on: {
              slideChangeTransitionEnd(this: {activeIndex: number}){
                Hours(rsp.vChampionList.value[this.activeIndex].iHour);
              },
            },
          })
        }
      })
  }, [current, tabCurrent])
  return (
    <div
      className='hour'
      id='toHour'
      style={
        {
          backgroundImage: `url(${tabCurrent === 1 ? hourback : hourback1})`
        }
      }
    >
      {
        list.length !== 0 &&
        <i className='hour-swiper'>
          {hours}时
        </i>
      }
      <section className='hourContent'>
        <div
          className = 'swiper-button-prev'
        ></div>
        <div className='swiper-container'>
          <div className='swiper-wrapper'>
            {
              list.map((item: ChampionInfo, index: number) => (
                <div className='swiper-slide' key={item.iHour + index}>
                  {
                    item.vChampionList.value.length !== 0 ?
                    item.vChampionList.value.map((items: RankItem, indexs: number) => {
                      if (indexs >= 13) return '';
                      return (
                        <HourItem
                          key={items.lUid}
                          index={indexs}
                          {...items}
                        />
                      )
                    })
                      :
                    <NoneData text={tabCurrent === 1 ? '黄金小时冠军即将诞生' : '小时冠军即将诞生'} />
                  }
                </div>
              ))
            }
          </div>
        </div>
        {
          list.length === 0 &&
          <NoneData text={tabCurrent === 1 ? '黄金小时冠军即将诞生' : '小时冠军即将诞生'} />
        }
        <div
          className = 'swiper-button-next'
        ></div>
      </section>
    </div>
  )
}

export default Hour;